/* eslint-disable key-spacing, no-multi-spaces */
import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import InlineSVG from 'svg-inline-react';
import './SelectList.scss';

import hotel from './hotel.svg';

export default class SelectListItem extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    contentType: PropTypes.string,
    href: PropTypes.string,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    nestingLevel: PropTypes.number,
    onItemChange: PropTypes.func,
    query: PropTypes.string,
    type: PropTypes.string,
    unavailable: PropTypes.bool,
    value: PropTypes.any,
    component: PropTypes.object,
  };

  static defaultProps = {
    checked: false,
    contentType: '',
    href: '#',
    nestingLevel: 0,
    query: '',
    type: '',
    unavailable: false,
    value: '',
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  itemClick = (event) => {
    const { onItemChange } = this.props;
    const dataset = event.currentTarget.dataset;
    if (!!onItemChange && dataset.type !== 'link') {
      event.preventDefault();
      onItemChange(dataset.value, dataset.checked === 'false');
    }
  }

  getName() {
    const { query, nestingLevel } = this.props;
    let { name } = this.props;
    if (query !== '') {
      name = name.replace(new RegExp(query, 'i'), '<span class="select-list__list__element__query">$&</span>');
    }
    return { __html: `${nestingLevel > 1 ? '- ' : ''}${name}` };
  }

  renderTextSpan() {
    const { unavailable, checked, type, contentType, component } = this.props;

    // if the content is a hotel, display a hotel icon
    const isHotel = contentType === 'HOTEL';

    return (
      <div>
        {component || (
          <span
            className={
              `select-list__list__element__span
              ${unavailable && !checked ? 'select-list__list__element__span--is-unavailable' : ''}
              ${isHotel ? 'select-list__list__element__span--with-icon' : ''}`
            }
            dangerouslySetInnerHTML={this.getName()}
          />
        )}
        { type !== 'empty' && <span
          className={`select-list__list__element__${type}${checked ? '--is-checked' : ''}`}
        /> }
        { isHotel && <InlineSVG src={hotel} className="select-list__list__element__icon" /> }
      </div>
    );
  }

  render() {
    const {
      checked,
      contentType,
      href,
      nestingLevel,
      type,
      unavailable,
      value,
    } = this.props;

    const className = `select-list__list__element__link select-list__list__element__link--nesting-level-${type !== 'empty' && nestingLevel}`;

    return (!unavailable || (checked && type === 'checkbox')) ? (
      <div>
        <a
          href={href || '#'}
          onClick={this.itemClick}
          className={className}
          data-value={value}
          data-checked={checked}
          data-type={contentType === 'HOTEL' ? 'link' : 'select'}
        >
          {this.renderTextSpan()}
        </a>
      </div>
    ) : <div className={className}>{this.renderTextSpan()}</div>;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectList/SelectListItem.jsx
 **/